<template>
  <div class="container">
    <b-modal
      :model-value="modAsociaDesasociaRol"
      :no-close-on-backdrop="true"
      hide-footer
      centered
      size="xl"
      dialog-class="modal-roles-wide"
      :title="infoMenu[0]?.nombre || labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog modal-fixed-height"
      @hide="cierraModal"
    >
      <div class="uniform-modal-body uniform-modal-body--wide">
        <div class="password-policy-box mb-4">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-subtitle">{{ labels.infoText }}</div>
        </div>

        <!-- ===== LISTA DE ROLES ===== -->
        <div class="roles-modal-body">
          <div
            v-for="rol in listRoles"
            :key="rol.id"
            class="role-row d-flex align-items-center justify-content-between"
          >
            <div class="role-name">{{ rol?.nombre }}</div>
            <!-- ===== TOGGLE PERSONALIZADO ===== -->
            <div class="custom-toggle-wrapper custom-toggle-sm">
              <input
                type="checkbox"
                :id="'toggle-role-' + rol.id"
                v-model="rolSelected"
                :value="rol?.id"
                @change="toggleRol(rol.id)"
                :checked="isRoleSelected(rol?.id)"
              />
              <label :for="'toggle-role-' + rol.id" class="toggle-label">
                <span class="toggle-slider"></span>
                <span class="toggle-text">
                  {{ isRoleSelected(rol?.id) ? labels.active : labels.inactive }}
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
          <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">
            {{ labels.close }}
          </b-button>
          <b-button class="reset-btn-primary" @click="guardarMenu">
            {{ labels.save }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu';
import Roles from '../../../services/Roles';

export default {
  name: "AsociaDesasociaRol",
  props: ['modAsociaDesasociaRol', 'infoMenu'],
  data: () => ({
    rolAsociados: [],
    listRoles: [],
    rolSelected: []
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Menú:",
          save: "Guardar",
          close: "Cerrar",
          active: "Activo",
          inactive: "Inactivo",
          infoTitle: "Roles del menú",
          infoText: "Activa o desactiva los roles asociados al menú."
        }
      } else {
        return {
          title: "Menu:",
          save: "Save",
          close: "Close",
          active: "Active",
          inactive: "Inactive",
          infoTitle: "Menu roles",
          infoText: "Toggle the roles associated with the menu."
        }
      }
    }
  },
  mounted() {
    console.log('=== [MOUNTED] Modal abierto ===')
    console.log('[MOUNTED] infoMenu recibido:', JSON.stringify(this.infoMenu, null, 2))

    Roles.getAllRoles()
      .then((res) => {
        this.listRoles = res.data.roles
        console.log('[MOUNTED] listRoles cargados:', JSON.stringify(this.listRoles, null, 2))
        if (this.infoMenu && this.infoMenu.length > 0) {
          this.processInfoMenu(this.infoMenu)
        }
      })
      .catch((err) => {
        console.log('[MOUNTED] Error cargando roles:', err)
      })
  },
  methods: {
    isRoleSelected(roleId) {
      return this.rolSelected.includes(roleId)
    },
    toggleRol(roleId) {
      console.log('=== [TOGGLE] Rol clickeado ===')
      console.log('[TOGGLE] roleId:', roleId)
      console.log('[TOGGLE] rolSelected DESPUÉS del cambio:', JSON.stringify(this.rolSelected))
    },
    cierraModal() {
      this.$emit('closeModal', false)
      this.rolSelected = []
    },
    processInfoMenu(dataMenu) {
      console.log('=== [PROCESS] processInfoMenu ejecutado ===')
      console.log('[PROCESS] dataMenu completo:', JSON.stringify(dataMenu, null, 2))

      if (!dataMenu || !dataMenu.length) {
        console.log('[PROCESS] dataMenu vacío, saliendo')
        return
      }

      let rol = []
      dataMenu.forEach(elem => {
        rol = elem.roles
      })

      console.log('[PROCESS] valor de "rol" extraído:', rol, '| tipo:', typeof rol)

      if (!rol) {
        console.log('[PROCESS] "rol" es falsy (undefined/null/""), saliendo')
        return
      }

      const numbers = []
      const arrayRol = String(rol).split(',')
      console.log('[PROCESS] arrayRol (split por coma):', arrayRol)

      arrayRol.forEach(element => {
        const num = Number(element.trim())
        if (!isNaN(num)) {
          numbers.push(num)
        }
      })

      console.log('[PROCESS] numbers parseados:', numbers)
      this.rolAsociados = [...numbers]

      this.rolSelected = numbers.filter(valor =>
        this.listRoles.some(option => option.id === valor)
      )

      console.log('[PROCESS] rolSelected FINAL:', JSON.stringify(this.rolSelected))
      console.log('=== [PROCESS] Fin ===')
    },
    guardarMenu() {
      console.log('=== [GUARDAR] Click en Guardar ===')
      console.log('[GUARDAR] infoMenu[0]:', JSON.stringify(this.infoMenu?.[0], null, 2))
      console.log('[GUARDAR] rolSelected a enviar:', JSON.stringify(this.rolSelected))

      if (!this.infoMenu || !this.infoMenu[0] || !this.infoMenu[0].id) {
        this.$toast.error("Error: No se encontró el menú")
        return
      }

      let datos = {
        'idMenu': this.infoMenu[0].id,
        'rolesAsociados': this.rolSelected
      }

      console.log('[GUARDAR] Payload enviado al backend:', JSON.stringify(datos))

      Menu.updateRolesByMenu(datos)
        .then((res) => {
          console.log('[GUARDAR] Respuesta backend:', res.data)
          if (res.status == 200) {
            this.$toast.success(res.data.message)
            this.$emit('updated')
            this.cierraModal()
          }
        })
        .catch((err) => {
          console.log('[GUARDAR] Error backend:', err)
          this.$toast.error("Error al actualizar los roles del menú")
        })
    }
  },
  watch: {
    infoMenu: {
      immediate: true,
      handler(dataMenu) {
        console.log('=== [WATCH infoMenu] Cambió infoMenu ===')
        console.log('[WATCH infoMenu] dataMenu:', JSON.stringify(dataMenu, null, 2))
        console.log('[WATCH infoMenu] listRoles.length:', this.listRoles.length)
        if (this.listRoles && this.listRoles.length > 0) {
          this.processInfoMenu(dataMenu)
        } else {
          console.log('[WATCH infoMenu] listRoles vacío, no procesa todavía')
        }
      }
    }
  }
}
</script>

<style scoped>
/* ===== MODAL CON ALTURA FIJA ===== */
.modal-fixed-height .modal-dialog {
  max-height: 90vh;
}

.modal-fixed-height .modal-content {
  max-height: 90vh;
  overflow: hidden;
  position: relative;
}

.modal-fixed-height .modal-body {
  overflow: hidden;
  padding: 24px 20px;
}

/* ===== ESTILOS DEL MODAL ===== */
.uniform-modal-body--wide {
  padding: 8px 4px 4px 4px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.password-policy-box {
  background: white;
  border-radius: 8px;
  padding: 16px 20px;
  border-left: 4px solid #2e507a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.password-policy-title {
  font-weight: 600;
  font-size: 15px;
  color: #2e507a;
  margin-bottom: 4px;
}

.password-policy-subtitle {
  font-size: 13px;
  color: #6c757d;
}

/* ===== LISTA DE ROLES ===== */
.roles-modal-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  min-height: 200px;
  max-height: 380px;
}

.role-row {
  padding: 12px 20px;
  border-bottom: 1px solid #f0f2f5;
  transition: background 0.2s;
}

.role-row:hover {
  background: #f8f9fa;
}

.role-row:last-child {
  border-bottom: none;
}

.role-name {
  font-size: 14px;
  color: #212529;
  font-weight: 500;
  padding-right: 16px;
  word-break: break-word;
  flex: 1;
}

/* ===== TOGGLE PERSONALIZADO ===== */
.custom-toggle-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.custom-toggle-wrapper input[type="checkbox"] {
  display: none;
}

.custom-toggle-wrapper .toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  margin: 0;
}

.custom-toggle-wrapper .toggle-slider {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  background-color: #ccc;
  border-radius: 10px;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.custom-toggle-wrapper .toggle-slider::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider {
  background-color: #2e507a;
}

.custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after {
  transform: translateX(14px);
}

.custom-toggle-wrapper input[type="checkbox"]:disabled + .toggle-label {
  opacity: 0.6;
  cursor: not-allowed;
}

.custom-toggle-wrapper .toggle-text {
  font-size: 12px;
  font-weight: 500;
  color: #495057;
  min-width: 48px;
  text-align: left;
}

/* ===== BOTONES ===== */
.uniform-actions-wrap {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
  flex-shrink: 0;
}

.reset-btn-secondary {
  background-color: #f8f9fa !important;
  border: 1px solid #ced4da !important;
  color: #495057 !important;
  padding: 8px 24px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.reset-btn-secondary:hover:not(:disabled) {
  background-color: #e9ecef !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.reset-btn-secondary:focus,
.reset-btn-secondary:active {
  box-shadow: none !important;
  outline: none !important;
}

.reset-btn-primary {
  background-color: #2e507a !important;
  border: 1px solid #2e507a !important;
  color: white !important;
  padding: 8px 24px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.reset-btn-primary:hover:not(:disabled) {
  background-color: #1f3f62 !important;
  border-color: #1f3f62 !important;
}

.reset-btn-primary:focus,
.reset-btn-primary:active {
  box-shadow: 0 0 0 0.2rem rgba(46, 80, 122, 0.25) !important;
}

/* ===== HEADER DEL MODAL ===== */
.reset-modal-header {
  background-color: #2e507a;
  color: white;
  padding: 16px 20px;
  border-radius: 8px 8px 0 0;
}

.reset-modal-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.reset-modal-body {
  padding: 24px 20px;
  background-color: #f8f9fa;
  overflow: hidden;
}

/* ===== SCROLLBAR ===== */
.roles-modal-body::-webkit-scrollbar {
  width: 6px;
}

.roles-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.roles-modal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.roles-modal-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .modal-fixed-height .modal-body {
    padding: 16px 12px;
  }

  .roles-modal-body {
    min-height: 150px;
    max-height: 300px;
  }

  .role-row {
    padding: 10px 16px;
  }

  .role-name {
    font-size: 13px;
  }

  .custom-toggle-wrapper .toggle-slider {
    width: 30px;
    height: 18px;
  }

  .custom-toggle-wrapper .toggle-slider::after {
    width: 14px;
    height: 14px;
    top: 2px;
    left: 2px;
  }

  .custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after {
    transform: translateX(12px);
  }

  .custom-toggle-wrapper .toggle-text {
    font-size: 11px;
    min-width: 42px;
  }

  .uniform-actions-wrap {
    flex-direction: column;
    margin-top: 12px;
    padding-top: 12px;
  }

  .uniform-actions-wrap .reset-btn-secondary,
  .uniform-actions-wrap .reset-btn-primary {
    width: 100%;
    margin: 4px 0 !important;
  }

  .reset-modal-body {
    padding: 16px 12px;
  }
}

@media (max-width: 576px) {
  .password-policy-box {
    padding: 12px 16px;
  }

  .password-policy-title {
    font-size: 14px;
  }

  .password-policy-subtitle {
    font-size: 13px;
  }

  .roles-modal-body {
    min-height: 120px;
    max-height: 250px;
  }

  .role-row {
    padding: 8px 12px;
  }

  .role-name {
    font-size: 12px;
  }

  .custom-toggle-wrapper .toggle-slider {
    width: 28px;
    height: 16px;
    border-radius: 8px;
  }

  .custom-toggle-wrapper .toggle-slider::after {
    width: 12px;
    height: 12px;
    top: 2px;
    left: 2px;
  }

  .custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after {
    transform: translateX(12px);
  }

  .custom-toggle-wrapper .toggle-text {
    font-size: 10px;
    min-width: 38px;
  }
}
</style>